<template>
  <div class="confirmBox">
    <!--  -->
    <div>
      <a-form
        class="formBox"
        :form="form"
      >
        <a-col
          span="12"
        >
          <!-- 作品名称-中文 -->
          <a-form-item
            :label="$t('user-productInfo-myProduct/name-zh')"
            required
          >
            <a-input
              v-model="form.name_cn"
              style="width: 80%;"
              :disabled="readonly"
            />
          </a-form-item>
        </a-col>
        <!-- 作品名称-英文 -->
        <!-- <a-col
          span="12"
        >
          <a-form-item
            :label="$t('user-productInfo-product/productEname')"
            required
          >
            <a-input
              v-model="form.name_en"
              style="width: 80%;"
              :disabled="readonly"
            />
          </a-form-item>
        </a-col> -->
        <!-- 该尺寸将用于您的作品3D打样，请再次复核产品尺寸并填写 -->
        <!-- <a-col
          span="24"
          style="color: #ff0000;font-size: 16px;"
        >
          {{ $t('admin-judge408/tip12') }}
        </a-col> -->
        <!-- 作品长度(毫米) -->
        <a-col
          span="12"
        >
          <a-form-item
            :label="$t('user-productInfo-logistics/hight')"
            required
          >
            <a-input
              v-model="form.height"
              style="width: 80%;"
              :disabled="readonly"
            />
          </a-form-item>
        </a-col>
        <!-- 作品宽度(毫米) -->
        <a-col
          span="12"
        >
          <a-form-item
            :label="$t('user-productInfo-logistics/width')"
            required
          >
            <a-input
              v-model="form.width"
              style="width: 80%;"
              :disabled="readonly"
            />
          </a-form-item>
        </a-col>
        <!-- 作品深度(毫米) -->
        <a-col
          span="12"
        >
          <a-form-item
            :label="$t('user-productInfo-logistics/depth')"
            required
          >
            <a-input
              v-model="form.depth"
              style="width: 80%;"
              :disabled="readonly"
            />
          </a-form-item>
        </a-col>
        <!-- 请上传CMYK格式图片，该图片将用于线下巡展、大赛作品集和官网公示等宣传中。 -->
        <a-col
          span="24"
          style="color: #ff0000;font-size: 16px;"
        >
          {{ $t('admin-judge408/tip13') }}
        </a-col>
        <!-- 上传图片按钮 -->
        <a-col span="24">
          <a-upload
            action=""
            list-type="picture-card"
            :file-list="form.thumbs"
            :before-upload="beforeUpload"
            :disabled="readonly"
            @preview="handlePreview"
            @change="handleChange"
          >
            <div>
              <a-button style="margin: 3px 15px 0 0;float:left;pointer-events: auto;color: #fa4646;border-color: #fa4646;"><a-icon type="upload" /> {{ $t('view-components-components/Upload') }}</a-button>
            </div>
          </a-upload>
          <div style="margin-top: 15px;">
            <font
              size="2.5"
              color="red"
              style="font-weight: bold;"
            >
              {{ $t('user-productInfo-description/uploadTip3') }}
            </font>
            <font
              size="2.5"
              color="666666"
            >
              {{ $t('user-productInfo-description/uploadTip4') }}
            </font>
          </div>
          <div style="margin-top: 8px;">
            <font
              size="2.5"
              color="666666"
            >
              {{ $t('user-productInfo-description/uploadTip') }}
            </font>
          </div>
          <!-- <div style="margin-top: 8px;">
            <font
              size="2.5"
              color="666666"
            >
              多媒体文件：将参赛作品中具有代表性的页面进行截图后提交至线上报名系统。此外多媒体文件还需以邮件形式提交到官方邮箱： zzid2020@163.com 。邮件内需备注“第六届“龙江杯”（漳州）工业设计创新大赛+作品编号”。作品时长不超过5分钟，文件大小不得超过100MB，格式为MOV或WMV或AVI/MP4或SWF或MPEG/MPG。
            </font>
          </div> -->
        </a-col>
        <!-- 该作品是否已有样品 -->
        <!-- <a-col
          span="24"
        >
          <a-form-item
            :label="$t('admin-judge408/tip14')"
            required
          >
            <a-radio-group v-model="form.is_sample" :disabled="readonly" @change="downloadFile">
              <a-radio :value="1">
                {{ $t('register/check') }}
              </a-radio>
              <a-radio :value="2">
                {{ $t('register/check2') }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col> -->
        <!-- 上面单选框选择否的时候-3D打样服务相关材料，请上传如下材料： -->
        <a-col
          v-show="form.is_sample === 2"
          span="24"
          style="margin-bottom: 10px;font-size: 13px;"
        >
          <div style="color: #ff0000;font-size: 16px;">{{ $t('admin-judge422/name') }}：</div>
          <!-- 3D打样服务相关材料，请上传如下材料： -->
          <div>（1）{{ $t('admin-judge422/name2') }}</div>
          <!-- （2）表面处理和喷漆的工艺说明（标注产品表面效果和喷漆颜色的潘通色号,潘通色号查询链接https://www.qtccolor.com/findColor.aspx或提供相关部件的参考材质图片。） -->
          <div>（2）{{ $t('admin-judge422/name3') }}<a href="javascript:void(0);" onclick="window.open('https://www.qtccolor.com/findColor.aspx')">https://www.qtccolor.com/findColor.aspx</a>{{ $t('admin-judge422/name4') }}</div>
          <!-- （3）产品丝印图（矢量）用于产品表面印刷符号logo文字等 -->
          <div>（3）{{ $t('admin-judge422/name5') }}</div>
          <!-- 注：如无上传该文件，视为自动放弃组委会提供的3D打样机会 -->
          <div>{{ $t('admin-judge422/name6') }}</div>
        </a-col>
        <a-col v-show="form.is_sample === 2" span="12" class="superman" style="border: 1px solid #999999;padding: 20px 32px;margin-left: 32px;">
          <!-- 3D打样服务相关材料上传 -->
          <div style="color: #000;">{{ $t('admin-judge423/name1') }}</div>
          <!-- 3D模型文件 -->
          <a-form-item
            :label="$t('admin-judge423/name2')"
            required
          >
            <!-- 上传的 stl/stp/igs模型文件请控制在长宽高为200mm的立方体以内 -->
            <div style="color: #999999;">{{ $t('admin-judge425/tip1') }}</div>
            <!-- 上传按钮 -->
            <a-upload
              :multiple="true"
              action=""
              :file-list="model_file"
              :disabled="readonly"
              @change="uploadFile1"
            >
              <a-button> <a-icon type="upload" /> {{ $t('admin-message-message/upload') }} (stl、stp、igs) </a-button>
            </a-upload>
          </a-form-item>
          <!-- 点击此处可查看表面处理和喷漆的工艺示例图 -->
          <div>{{ $t('admin-judge423/name5') }}<a href="javascript:void(0);" @click="viewExample">{{ $t('admin-judge423/name6') }}</a></div>
          <!-- 表面处理和喷漆的工艺说明 -->
          <a-form-item
            :label="$t('admin-judge423/name3')"
            required
          >
            <!-- 上传按钮 -->
            <a-upload
              :multiple="true"
              action=""
              :file-list="thumbs1"
              list-type="picture-card"
              :disabled="readonly"
              @preview="handlePreview2"
              @change="uploadFile3"
            >
              <a-button> <a-icon type="upload" /> {{ $t('admin-message-message/upload') }} (jpg、png) </a-button>
            </a-upload>
          </a-form-item>
          <!-- 产品丝印图 -->
          <a-form-item
            :label="$t('admin-judge423/name4')"
            style="margin-top: 20px;"
          >
            <!-- 上传按钮 -->
            <a-upload
              :multiple="true"
              action=""
              :file-list="silk_file"
              :disabled="readonly"
              @change="uploadFile2"
            >
              <a-button> <a-icon type="upload" /> {{ $t('admin-message-message/upload') }} (cdr、AI) </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
        <!-- <a-col
          span="24"
        >
          <a-form-item
            :label="$t('admin-judge318/tip1')"
            required
          >
            <a-radio-group v-model="form.is_copyright" :disabled="readonly" @change="e => showModal = e.target.value === 2">
              <a-radio :value="1">
                {{ $t('register/check') }}
              </a-radio>
              <a-radio :value="2">
                {{ $t('register/check2') }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col> -->
        <a-col
          span="12"
        >
          <!-- 单位名称（奖杯/奖状如需体现请填写） -->
          <a-form-item
            :label="$t('admin-judge420/name1')"
          >
            <a-input
              v-model="form.company_name"
              :disabled="readonly"
            />
          </a-form-item>
        </a-col>
        <a-col
          span="24"
        >
          <!-- 设计方姓名（设计团队最多不能超过4人） -->
          <a-form-item
            v-for="(item, index) in form.design_addrss"
            :key="index"
            :label="index === 0 ? $t('view-components-components/designerName') + $t('admin-judge318/tip2') : $t('view-components-components/designerName')"
            required
          >
            <!-- <a-input v-if="locale !== 'en'" v-model="item.lastname" :disabled="readonly" :placeholder="$t('register/lastname')" style="width: 19%;margin-right: 2%;" />
            <a-input v-model="item.firstname" :disabled="readonly" :placeholder="$t('register/firstname')" style="width: 19%;margin-right: 2%;" />
            <a-input v-if="locale === 'en'" v-model="item.lastname" :disabled="readonly" :placeholder="$t('register/lastname')" style="width: 19%;margin-right: 2%;" /> -->
            <!-- 单选框和按钮 -->
            <a-input v-model="item.fullname" :disabled="readonly" :placeholder="''" style="width: 30%;margin-right: 2%;" />
            <a-button v-show="index === 0 && !readonly" style="margin-right: 5px;" @click="addItem">+</a-button>
            <a-button v-show="index > 0 && !readonly" @click="delItem(index)">-</a-button>
          </a-form-item>
        </a-col>
        <!-- 作品联系人 -->
        <a-col
          span="6"
          style="margin-top: 20px;"
        >
          <a-form-item
            :label="$t('admin-judge420/name2')"
            required
          >
            <a-input
              v-model="form.contacts"
              :disabled="readonly"
              style="width: 90%;"
            />
          </a-form-item>
        </a-col>
        <!-- 电话 -->
        <a-col
          span="6"
          style="margin-top: 20px;"
        >
          <a-form-item
            :label="$t('view-components-components/telephoneNumber')"
            required
          >
            <a-input
              v-model="form.contact_number"
              :disabled="readonly"
              style="width: 90%;"
            />
          </a-form-item>
        </a-col>
        <!-- 邮箱 -->
        <a-col
          span="6"
          style="margin-top: 20px;"
        >
          <a-form-item
            :label="$t('register/workEmail')"
            required
          >
            <a-input
              v-model="form.email"
              :disabled="readonly"
              style="width: 90%;"
            />
          </a-form-item>
        </a-col>
        <!-- 请在下方填写您的银行账户信息（该信息将用于金奖/银奖的含税奖金发放，优胜奖无需填写。） -->
        <div v-show="locale === 'zh'">
          <a-col :span="24" style="margin-top: 20px;color:#000;font-size: 16px;">请在下方填写您的银行账户信息<span style="color: #ff0000;">（该信息将用于金奖/银奖/铜奖的含税奖金发放，优胜/入围无需填写。）</span></a-col>
          <a-col
            span="6"
          >
            <!-- 收款个人/单位名称-下方输入框 -->
            <a-form-item
              :label="'收款个人/单位名称'"
            >
              <a-input
                v-model="form.payee"
                :disabled="readonly"
                style="width: 90%;"
              />
            </a-form-item>
          </a-col>
          <!-- 收款人身份证号码-下方输入框 -->
          <a-col
            span="6"
          >
            <a-form-item
              :label="'收款人身份证号码'"
            >
              <a-input
                v-model="form.id_number"
                :disabled="readonly"
                style="width: 90%;"
              />
            </a-form-item>
          </a-col>
          <!-- 收款人联系电话 -->
          <a-col
            span="6"
          >
            <a-form-item
              :label="'收款人联系电话'"
            >
              <a-input
                v-model="form.payee_phone"
                :disabled="readonly"
                style="width: 90%;"
              />
            </a-form-item>
          </a-col>
          <!-- 收款开户行（精确到支行） -->
          <a-col
            span="8"
          >
            <a-form-item
              :label="'收款开户行（精确到支行）'"
            >
              <a-input
                v-model="form.receiving_bank"
                :disabled="readonly"
                style="width: 90%;"
              />
            </a-form-item>
          </a-col>
          <!-- 收款账号 -->
          <a-col
            span="8"
          >
            <a-form-item
              :label="'收款账号'"
            >
              <a-input
                v-model="form.bank_number"
                :disabled="readonly"
                style="width: 90%;"
              />
            </a-form-item>
          </a-col>
          <!-- 请上传您的身份证正反面复印件，并再复印件上签上姓名及联系电话。 -->
          <a-col span="12" class="superman">
            <div style="color: rgba(0,0,0,0.85);font-size: 14px;">请上传您的身份证正反面复印件，并再复印件上签上姓名及联系电话。</div>
            <!-- 点击上传 -->
            <a-form-item
              :label="''"
            >
              <a-upload
                :multiple="true"
                action=""
                :file-list="id_card_pdf"
                :disabled="readonly"
                @change="uploadFile4"
              >
                <a-button> <a-icon type="upload" /> {{ $t('admin-message-message/upload') }} (pdf) </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
        </div>
        <!-- 收货地址（用于奖状/奖杯寄送，运费参赛者自理） -->
        <a-col :span="24" style="margin-top: 20px;color:#000;font-size: 16px;">{{ $t('admin-judge318/ReceivingAddress') }}</a-col>
        <a-col
          span="4"
        >
          <!-- 国家-下拉列表 -->
          <a-form-item
            :label="$t('admin-judge420/name10')"
            required
          >
            <a-select
              v-model="form.receiving_country"
              show-search
              :disabled="readonly"
              :placeholder="$t('user-productInfo-brand/country')"
              style="width: 90%;"
            >
              <a-select-option
                v-for="i in countryFormat[$i18n.locale || 'zh']"
                :key="i"
                :value="i"
              >
                {{ i }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 省份-下拉列表 -->
        <a-col
          v-if="form.receiving_country === 'China' || form.receiving_country === '中国'"
          span="4"
        >
          <a-form-item
            :label="$t('admin-judge420/name7')"
            required
          >
            <a-select
              v-model="form.receiving_province"
              show-search
              :disabled="readonly"
              :placeholder="$t('admin-judge420/name7')"
              style="width: 90%;"
              @change="form.receiving_city = ''"
            >
              <a-select-option
                v-for="i in provinceData"
                :key="i"
                :value="i"
              >
                {{ i }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 城市-下拉列表 -->
        <a-col
          span="4"
        >
          <a-form-item
            :label="$t('register/city')"
            required
          >
            <a-input
              v-if="form.receiving_country !== 'China' && form.receiving_country !== '中国'"
              v-model="form.receiving_city"
              :disabled="readonly"
              :placeholder="$t('user-productInfo-brand/city')"
              style="width: 90%;"
            />
            <a-select
              v-if="form.receiving_country === 'China' || form.receiving_country === '中国'"
              v-model="form.receiving_city"
              show-search
              :disabled="readonly"
              :placeholder="$t('user-productInfo-brand/city')"
              style="width: 90%;"
              @change="form.receiving_region = ''"
            >
              <a-select-option
                v-for="i in cityData"
                :key="i"
                :value="i"
              >
                {{ i }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 具体地址 -->
        <a-col
          span="12"
        >
          <a-form-item
            :label="$t('admin-judge420/name11')"
            required
          >
            <a-input
              v-model="form.receiving_address"
              :disabled="readonly"
              placeholder="地址"
            />
          </a-form-item>
        </a-col>
      </a-form>
    </div>
    <PreviewImage v-if="previewVisible" :images="images" :index="imagesIndex" @closePreview="closePreview" />
    <footer>
      <!-- 返回 -->
      <a-button
        @click="goBack"
      >
        {{ $t('view-components-components/return') }}
      </a-button>
      <!-- 保存 -->
      <a-button
        v-show="!readonly"
        @click="confirmSubmit(false)"
      >
        {{ $t('view-components-components/modify') }}
      </a-button>
      <!-- 确认提交 -->
      <a-button
        v-show="!readonly"
        type="primary"
        @click="confirmSubmit(true)"
      >
        {{ $t('view-components-components/submit') }}
      </a-button>
    </footer>
    <!-- 点击保存出现的模态框 -->
    <Modal
      :show-modal="showModal"
      :cancel-text="$t('register-verify/close')"
      :show-confirm="false"
      @cancel="showModal = false"
    >
      <!-- <a href="javascript:void(0);" onclick="window.open('http://www.v-award.com')">http://www.v-award.com</a> -->
      <div>版权登记链接: <a href="http://reg.hxnce.net" target="blank">http://reg.hxnce.net</a></div>
      <div>如需版权服务，点击版权登记链接进行在线版权登记。（组委会已替您的获奖作品缴纳版权登记费，您无需缴费）。</div>
      <div>若<span style="color: #ff0000;">9月15日</span>前您仍未进行登记，则视为主动放弃该服务，登记与否不影响获奖结果。</div>
    </Modal>
    <!-- <Modal
      :show-modal="showModal2"
      :cancel-text="$t('register-verify/close')"
      :show-confirm="false"
      @cancel="showModal2 = false"
    >
      <a :href="`javascript: window.open('${request.defaults.baseURL}/storage/pdf/获奖作品物流寄送须知（Information of Winning Product Delivery）.pdf')`">{{ $t('admin-judge425/name1') }}</a>
    </Modal> -->
  </div>
</template>
<script>
// 请求
import { products, productsUploadImage, productsConfirmUpdate, productsFileUpload, productsDeleteFile } from '@/api/product'
import PreviewImage from '@/views/components/PreviewImage' // 预览图子组件
import countryFormat from '@/utils/country.js' // 国家格式化-可能指的是名字
import area_cn from '@/utils/area_cn.js' // 中文
import area_en from '@/utils/area_en.js' // 英文
import exampleImg from '@/assets/example.png' // 例子图片
import Modal from '@/views/components/Modal.vue' // 模态框子组件
import request from '@/utils/request' // 请求
// 得到图片的64位
function getBase64(files) {
  return new Promise((resolve, reject) => {
    if (!files.length) {
      const reader = new FileReader()
      reader.readAsDataURL(files)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    } else {
      // 多图片转换
      const array = []
      const length = files.length
      for (const i in files) {
        const reader = new FileReader()
        reader.readAsDataURL(files[i])
        reader.onload = function() {
          array.push(reader.result)
          if (array.length === length) {
            resolve(array)
          }
        }
        reader.onerror = error => reject(error)
      }
    }
  })
}

export default {
  components: {
    PreviewImage,
    Modal
  },
  props: {
    confirmId: { // 传来的参数-作品的ID
      default: 0,
      type: Number
    },
    readonly: { // 父组件传来的值，判断某块区域只读
      default: false,
      type: Boolean
    }
  },
  data: function() {
    return {
      markUId: '', // 上传文件或者图片之前
      images: [], // 预览图
      imagesIndex: 0, // 预览图索引
      previewVisible: false, // 是否展示预览图
      form: { // 提交的内容
        name_cn: '', // 中文作品名
        name_en: '', // 英文作品名
        height: '', // 高度
        width: '', // 宽度
        depth: '', // 厚度
        company_name: '', // 单位名称
        thumbs: [], // 上传的图片有关数组信息(可能事图片数组)
        design_addrss: [], // 设计方姓名，最多四个
        is_sample: '', // 判断第一个按钮组选中的是还是否
        is_copyright: '', // 判断第二个按钮组选中的是还是否
        contacts: '', // 作品联系人
        contact_number: '', // 作品人联系电话
        email: '', // 作品人联系邮箱
        payee: '', // 收款个人-单位名称
        id_number: '', // 收款个人-身份证号
        payee_phone: '', // 收款人联系电话
        receiving_bank: '', // 收款开户行（精确到支行）
        bank_number: '', // 收款账号
        receiving_country: '', // 收货地址-国家
        receiving_province: '', // 收货地址-省份
        receiving_city: '', // 收货地址-城市名称
        receiving_address: '' // 收货地址-具体门牌号
      },
      countryFormat: countryFormat, //  所有的国家
      model_file: [], // 3D模型文件上传
      silk_file: [], // 产品丝印图文件(图片)上传
      thumbs1: [], // 表面处理和喷漆的工艺说明文件(图片)上传
      id_card_pdf: [], // 正反面复印件图片
      showModal: false, // 展示-点击保存出现的模态框
      showModal2: false, // 没有用到
      request: request // 请求
    }
  },
  computed: {
    locale() { // 本地化
      return this.$i18n.locale
    },
    provinceData() { // 所有的省份
      return this.locale === 'en' ? area_en.provinceData : area_cn.provinceData
    },
    cityData() { // 所有的城市
      const area = this.locale === 'en' ? area_en : area_cn
      return area.cityData[this.form.receiving_province]
    }
  },
  watch: {
    'form.design_addrss'() { // 监听设计方姓名，如果长度小于0就，重置
      if (this.form.design_addrss.length <= 0) {
        this.form.design_addrss = [{
          // lastname: '',
          // firstname: '',
          fullname: ''
        }]
      }
    }
  },
  created() {
    this.getDetail(this.confirmId) // 执行函数
  },
  methods: {
    getDetail(id) { // 初始化所有的值
      products(id).then(res => {
        console.log(res.product.name_cn, res.product.name_en, res.product)
        this.dataBackup = res.product // 只出现一次，目测无用
        this.form.name_cn = res.product.name_cn // 中文作品名
        this.form.name_en = res.product.name_en // 英文作品名
        this.form.height = res.product.height // 高度
        this.form.width = res.product.width
        this.form.depth = res.product.depth
        this.form.company_name = res.product.company_name
        this.form.thumbs = res.product.thumbs.map((item, index) => { // 已经上传的图片数组信息
          return {
            uid: index,
            url: item,
            name: 'image.png',
            status: 'done'
          }
        })
        this.form.is_sample = res.product.is_sample // 第一组按钮组
        this.form.is_copyright = res.product.is_copyright // 第二个按钮组
        this.form.contacts = res.product.contacts //
        this.form.contact_number = res.product.contact_number
        this.form.email = res.product.email
        this.form.payee = res.product.payee
        this.form.id_number = res.product.id_number
        this.form.payee_phone = res.product.payee_phone
        this.form.receiving_bank = res.product.receiving_bank
        this.form.bank_number = res.product.bank_number
        this.form.receiving_country = res.product.receiving_country
        if (!this.form.receiving_country) { // 如果没有值，就默认为中国
          this.form.receiving_country = '中国'
        }
        this.form.receiving_province = res.product.receiving_province
        this.form.receiving_city = res.product.receiving_city
        this.form.receiving_address = res.product.receiving_address
        this.$set(this.form, 'design_addrss', res.product.design_addrss.map(i => {
          return {
            address_id: i.address_id,
            // lastname: i.address.contact[0].lastname,
            // firstname: i.address.contact[0].firstname
            fullname: i.address.contact[0].fullname
          }
        }))
        // 添加一个变量(3D模型文件)到组件实例上，
        this.$set(this, 'model_file', res.product.model_file.map(i => {
          return {
            id: i.id,
            name: i.name,
            uid: i.id,
            status: 'done'
          }
        }))
        // 添加一个变量(产品丝印图)到组件实例上
        this.$set(this, 'silk_file', res.product.silk_file.map(i => {
          return {
            id: i.id,
            name: i.name,
            uid: i.id,
            status: 'done'
          }
        }))
        // 添加一个变量(表面处理和喷漆的工艺说明文件(图片)上传)到组件实例上
        this.$set(this, 'thumbs1', res.product.thumbs1.map((item, index) => {
          return {
            uid: index,
            url: item,
            name: 'image.png',
            status: 'done'
          }
        }))
        // 正反面复印件
        this.$set(this, 'id_card_pdf', res.product.id_card_pdf.filter(i => !!i).map(i => {
          return {
            id: i.id,
            name: i.name,
            uid: i.id,
            status: 'done'
          }
        }))
      }).catch(res => {
        console.error(res)
      })
    },
    productSave(bool, data) {
      productsConfirmUpdate(this.confirmId, data).then(res => {
        console.log(res)
        if (bool) { // 提示语句
          this.$message.success({ content: this.$t('view-components-components/submitTip'), key: 'message', duration: 4 })
        } else { // 提示语句
          this.$message.success({ content: this.$t('admin-password-password/savey'), key: 'message', duration: 4 })
        }
        this.goBack()
      })
    },
    beforeUpload(e) { // 上传之前，存储文件的id等信息
      console.log(e)
      this.markUId = e.uid
    },
    async handlePreview(file, type) { // 先判断点击的是哪个上传图片的数组(表面处理和喷漆的工艺说明文件(图片)上传和普通的上传图片数组)，再预览
      let imagesIndex = 0
      this.images = (type ? this.thumbs1 : this.form.thumbs).map((item, index) => {
        if (item.url === file.url) imagesIndex = index
        return item.url.replace('-thumb', '')
      })
      this.imagesIndex = imagesIndex
      this.previewVisible = true
    },
    handlePreview2(file) { // 进行某个数组的预览
      this.handlePreview(file, 2)
    },
    handleChange({ fileList }) { // 当普通的上传图片按钮上传或者删除图片后，进行的代码
      // 长度变短表示删除
      if (fileList.length < this.form.thumbs.length) {
        const that = this
        this.$confirm({ // 这是提示信息
          content: this.$t('view-components-components/deleteConfirm'),
          okText: this.$t('view-components-components/confirm'),
          cancelText: this.$t('admin-profile-edit/cancel'),
          onOk() { // 点击OK执行的代码
            that.form.thumbs = fileList
            that.saveImages(true)
          },
          onCancel() { // 点击取消执行的代码
          }
        })

        return
      }
      this.form.thumbs = fileList // 把最新数组赋值给普通的上传图片数组
      // 图片不单独上传，未配服务器地址时图片会出现红框
      for (const i in this.form.thumbs) {
        this.form.thumbs[i].status = 'success'
      }
      // 可能插件原因图片上传会影响到下面文件上传
      this.model_file.map(i => {
        i.status = 'success'
      })

      const file = fileList[fileList.length - 1]

      if (file.uid === this.markUId) {
        if (file.size / 1024 / 1024 > 10) {
          this.$message.error({ content: this.$t('view-components-components/big'), key: 'message', duration: 4 })
          this.form.thumbs.splice(this.form.thumbs.length - 1, 1)
          return
        }
        if (this.form.thumbs.length > 10) {
          this.$message.error({ content: this.$t('view-components-components/big2'), key: 'message', duration: 4 })
          this.form.thumbs.splice(this.form.thumbs.length - 1, 1)
          return
        }
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          this.$message.error({ content: this.$t('view-components-components/product'), key: 'message' })
          this.form.thumbs.splice(this.form.thumbs.length - 1, 1)
          return
        }
      }
      if (file.percent === 0) {
        this.saveImages()
      }
    },
    async saveImages(delBool) { // 猜测可能是保存之前的上传的图片数组
      // e.preventDefault()
      // e.stopPropagation()
      const data = {
        thumbs: this.form.thumbs
      }
      const that = this

      const imgsList = []
      data.old_images = []
      for (const i in data.thumbs) {
        if (data.thumbs[i].url) {
          data.old_images.push(data.thumbs[i].url.replace('-thumb', ''))
        } else {
          imgsList.push(data.thumbs[i].originFileObj)
        }
      }
      console.log(imgsList)
      data.thumbs = imgsList.length ? await getBase64(imgsList) : [] // 转化图片位64位
      this.showLoading = true

      data.images = data.thumbs
      productsUploadImage(this.confirmId, data).then(res => { // 可能是在保存图片
        this.$emit('setSavedImagesNum', data.thumbs.length + data.old_images.length)
        for (const i in that.form.thumbs) {
          that.form.thumbs[i].isSaved = true
        }
        this.showLoading = false
        if (!delBool) this.$message.success({ content: this.$t('view-components-components/uploadSuccess'), key: 'message', duration: 4 })
        if (imgsList.length) this.form.thumbs[this.form.thumbs.length - 1].url = res.image_url
      }).catch(e => {
        this.showLoading = false
        this.$message.error({ content: this.$t('view-components-components/uploadFail'), key: 'message', duration: 4 })
        this.form.thumbs.splice(this.form.thumbs.length - 1, 1)
      })
    },
    async handleChange2({ file, fileList }, type) {
      if (!file.originFileObj && file.status !== 'removed') return

      const arr = ['', this.model_file, this.silk_file, this.thumbs1, this.id_card_pdf][type]
      this.showLoading = true

      if (file.status !== 'removed') {
        if ((type === 1 && !/stl|igs|stp/.test(file.name.toLowerCase())) ||
          (type === 2 && !/cdr|ai/.test(file.name.toLowerCase())) ||
          (type === 3 && !/jpeg|jpg|png/.test(file.name.toLowerCase())) ||
          (type === 4 && !/pdf/.test(file.name.toLowerCase()))) {
          return this.$message.error({ content: this.$t('admin-judge423/formatError'), key: 'message', duration: 4 })
        }

        if (type === 3) {
          const data = {}
          data.old_images = []
          for (const i in this.thumbs1) {
            if (this.thumbs1[i].url) {
              data.old_images.push(this.thumbs1[i].url.replace('-thumb', ''))
            }
          }
          data.thumbs = await getBase64(file.originFileObj) || []

          data.images = data.thumbs
          data.type = 2
          productsUploadImage(this.confirmId, data).then(res => {
            this.showLoading = false
            this.$message.success({ content: this.$t('view-components-components/uploadSuccess'), key: 'message', duration: 4 })
            arr.push({
              uid: arr.length,
              url: res.image_url,
              name: 'image.png',
              status: 'done'
            })
          }).catch(e => {
            this.showLoading = false
            this.$message.error({ content: this.$t('view-components-components/uploadFail'), key: 'message', duration: 4 })
          })
        } else {
          const data = new FormData()
          data.append('type', type === 4 ? 3 : type)
          data.append('file', file.originFileObj)

          productsFileUpload(this.confirmId, data).then(res => {
            this.showLoading = false
            this.$message.success({ content: this.$t('view-components-components/uploadSuccess2'), key: 'message', duration: 4 })
            arr.push({
              id: res,
              name: file.name,
              uid: file.uid
            })
            arr.map(i => {
              i.status = 'success'
            })
          })
        }
      } else {
        if (type === 3) {
          const data = {
            type: 2,
            old_images: []
          }

          for (const i in this.thumbs1) {
            if (this.thumbs1[i].url) {
              if (this.thumbs1[i].status !== 'removed') data.old_images.push(this.thumbs1[i].url.replace('-thumb', ''))
            }
          }
          productsUploadImage(this.confirmId, data).then(res => {
            this.showLoading = false
            this.$message.success({ content: this.$t('view-components-components/deleteSucceeded'), key: 'message', duration: 4 })
            this.thumbs1 = this.thumbs1.filter(i => i.status !== 'removed')
          })
        } else {
          const index = arr.map(i => i.uid).indexOf(file.uid)
          productsDeleteFile(file.id).then(res => {
            this.showLoading = false
            this.$message.success({ content: this.$t('view-components-components/deleteSucceeded'), key: 'message', duration: 4 })
            arr.splice(index, 1)
          })
        }
      }
    },
    uploadFile1(arg) {
      this.handleChange2(arg, 1)
    },
    uploadFile2(arg) {
      this.handleChange2(arg, 2)
    },
    uploadFile3(arg) {
      this.handleChange2(arg, 3)
    },
    uploadFile4(arg) {
      this.handleChange2(arg, 4)
    },
    closePreview() {
      this.previewVisible = false
    },
    addItem() {
      if (this.form.design_addrss.length >= 4) return
      this.form.design_addrss.push({
        // lastname: '',
        // firstname: ''
        fullname: ''
      })
    },
    delItem(index) {
      this.form.design_addrss.splice(index, 1)
    },
    confirmSubmit(bool) {
      const that = this
      const data = {
        name_cn: this.form.name_cn,
        name_en: this.form.name_en,
        height: this.form.height,
        width: this.form.width,
        depth: this.form.depth,
        company_name: this.form.company_name,
        is_sample: this.form.is_sample,
        is_copyright: this.form.is_copyright,
        contacts: this.form.contacts,
        contact_number: this.form.contact_number,
        email: this.form.email,
        payee: this.form.payee,
        id_number: this.form.id_number,
        payee_phone: this.form.payee_phone,
        receiving_bank: this.form.receiving_bank,
        bank_number: this.form.bank_number,
        receiving_country: this.form.receiving_country,
        receiving_province: this.form.receiving_province,
        receiving_city: this.form.receiving_city,
        receiving_address: this.form.receiving_address,
        design_addrss: this.form.design_addrss,
        confirmation_status: bool ? 1 : 0
      }

      if (bool) {
        // 效验
        const checker = {
          name_cn: {
            bool: !data.name_cn,
            content: this.$t('view-components-components/tip27')
          },
          height: {
            bool: !data.height,
            content: this.$t('view-components-components/tip34')
          },
          width: {
            bool: !data.width,
            content: this.$t('view-components-components/tip35')
          },
          depth: {
            bool: !data.depth,
            content: this.$t('view-components-components/tip36')
          },
          is_sample: {
            bool: typeof data.is_sample !== 'number' || data.is_sample === 0,
            content: this.$t('admin-judge420/name6')
          },
          is_copyright: {
            bool: typeof data.is_copyright !== 'number' || data.is_copyright === 0,
            content: this.$t('admin-judge318/tip7')
          },
          contacts: {
            bool: !data.contacts,
            content: this.$t('admin-judge420/name3')
          },
          contact_number: {
            bool: !data.contact_number,
            content: this.$t('admin-judge420/name4')
          },
          email: {
            bool: !data.email,
            content: this.$t('admin-judge420/name5')
          },
          receiving_country: {
            bool: !data.receiving_country,
            content: this.$t('register/pcountry')
          },
          receiving_city: {
            bool: !data.receiving_city,
            content: this.$t('register/pcity')
          },
          receiving_address: {
            bool: !data.receiving_address,
            content: this.$t('admin-judge318/tip8')
          }
        }
        for (const i in checker) {
          if (checker[i].bool) {
            return this.$message.error({ content: checker[i].content, key: 'message', duration: 4 })
          }
        }

        if (this.form.email.indexOf('@') === -1) {
          return this.$message.error({ content: this.$t('view-components-components/mailError'), key: 'message', duration: 4 })
        }

        if (this.form.thumbs.length < 3) {
          return this.$message.error({ content: this.$t('view-components-components/least'), key: 'message', duration: 4 })
        }

        for (const i in data.design_addrss) {
          if (!data.design_addrss[i].fullname) {
            return this.$message.error({ content: this.$t('view-components-components/design'), key: 'message', duration: 4 })
          }
        }

        if (data.is_sample === 2 && (!this.thumbs1.length || !this.model_file.length)) {
          return this.$message.error({ content: this.$t('admin-judge423/name7'), key: 'message', duration: 4 })
        }

        // if (this.locale === 'zh' && (!data.payee || !data.id_number || !data.payee_phone || !data.receiving_bank || !data.bank_number || !this.id_card_pdf.filter(i => !!i).length)) {
        //   return this.$message.error({ content: '请完善银行账户信息', key: 'message', duration: 4 })
        // }

        this.$confirm({
          content: this.$t('admin-judge318/tip9'),
          okText: this.$t('register-verify/submit'),
          cancelText: this.$t('admin-profile-edit/cancel'),
          onOk() {
            that.productSave(true, data)
          },
          onCancel() {
          }
        })
      } else {
        this.$info({
          title: '',
          content: this.$t('admin-judge420/name8'),
          okText: this.$t('admin-judge420/name9')
        })

        delete data.confirmation_status
        this.productSave(false, data)
      }
    },
    goBack() {
      this.$emit('goBack')
    },
    viewExample() {
      window.open(exampleImg)
    },
    downloadFile(e) {
      console.log(`${this.request.defaults.baseURL}/storage/pdf/获奖作品物流寄送须知（Information of Winning Product Delivery）.pdf`)
      if (e.target.value === 1) {
        window.open(`${this.request.defaults.baseURL}/storage/pdf/获奖作品物流寄送须知（Information of Winning Product Delivery）.pdf`)
      }
    }
  }
}
</script>
<style scoped>
  footer {
    padding: 19px 24px;
    clear: both;
    text-align: center;
  }

  footer button {
    margin-left: 16px;
  }
</style>
<style>
  .confirmBox .ant-form-horizontal .ant-col.ant-form-item-control-wrapper {
    height: auto;
  }

  .confirmBox .superman .ant-upload-list {
    padding-bottom: 40px;
  }

  .confirmBox .superman .ant-upload.ant-upload-select{
    position: absolute;
    bottom: 0;
  }

  .confirmBox .superman .ant-form-item-children{
    position: unset;
  }

  .confirmBox .superman .ant-upload-list-text .anticon-delete {
    transform: scale(1.5);
  }
</style>
